<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ItineraryOverviewList from '../../components/itinerary/ItineraryOverviewList';
import TwTitleBar from '../../components/TwTitleBar';

export default {
  name: 'ItineraryOverview',
  components: {
    TwTitleBar,
    ItineraryOverviewList,
  },
  data() {
    return {
      breadcrumbs: [
        { text: this.$t('menu.itinerary.title'), to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.itinerary.overview.loading,
      productTypesLoading: state => state.itinerary.productTypes.loading,
      productTypes: state => state.itinerary.productTypes.items,
      createLoading: state => state.itinerary.create.loading,
      createError: state => state.itinerary.create.error,
    }),
    ...mapGetters({
      mapItineraryOverview: 'itinerary/mapItineraryOverview',
    }),
  },
  methods: {
    ...mapActions({
      getItineraries: 'itinerary/getItineraries',
      getProductTypes: 'itinerary/getProductTypes',
      createItinerary: 'itinerary/createItinerary',
    }),
  },
  created() {
    this.getProductTypes();
    this.getItineraries();
  },
};
</script>

<template>
  <v-content>
    <tw-title-bar
      :title="$t('menu.itinerary.pages.overview.title')"
      :breadcrumbs="breadcrumbs">
    </tw-title-bar>
    <itinerary-overview-list
      :product-types="productTypes"
      :product-types-loading="productTypesLoading"
      :items="mapItineraryOverview"
      :loading="loading"
      :create-loading="createLoading"
      :create-error="createError"
      @createItinerary="createItinerary"
      @refresh="getItineraries"/>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryOverview.vue